import { render, staticRenderFns } from "./logisticsModeTree.vue?vue&type=template&id=804c434a&scoped=true&"
import script from "./logisticsModeTree.vue?vue&type=script&lang=js&"
export * from "./logisticsModeTree.vue?vue&type=script&lang=js&"
import style0 from "./logisticsModeTree.vue?vue&type=style&index=0&id=804c434a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804c434a",
  null
  
)

export default component.exports